import ClearAppCache from "./ClearAppCache";
import PluginVersion from "./PluginVersion";

const AppCache = async () => {

    const getPluginVersion = await PluginVersion();
    const getCachePluginVersion = localStorage.getItem('pluginVersion');

    if(getPluginVersion !== getCachePluginVersion){
        ClearAppCache()
        localStorage.setItem('pluginVersion',getPluginVersion)
    }
}

export default AppCache